import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Trans, useTranslation } from 'react-i18next';

import { ClickableTypography } from '@/components/dashboard/components/loan-action-card/loan-action-card-builder/clickable-typography';

const paragraphLinks = {
  '7': 'https://pragmago.pl/marketing/dokumenty/zgoda-bik-wiecej-informacji-1.pdf',
  '11': 'https://pragmago.pl/marketing/dokumenty/zgoda-bik-wiecej-informacji-2.pdf',
  emailInfoBig: 'info@big.pl',
  emailIodBig: 'iod@big.pl',
  '15': 'https://pragmago.pl/marketing/dokumenty/zgoda-bik-wiecej-informacji-3.pdf',
};
export function BikbigTerms() {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t('loanFormPage.agreements.form.fields.bikbig.title')}
      </Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph1')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph2')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph3')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph4')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph5')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph6')}</Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => window.open(paragraphLinks['7'], '_blank')}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph7"
          values={{
            link: paragraphLinks['7'],
          }}
        >
          {t('loanFormPage.agreements.form.fields.bikbig.content.paragraph7')}
        </Trans>
      </Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph8')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph9')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph10')}</Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => window.open(paragraphLinks['11'], '_blank')}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph11"
          values={{
            link: paragraphLinks['11'],
          }}
        />
      </Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph12')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph13')}</Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => (window.location.href = `mailto:${paragraphLinks.emailInfoBig}`)}
            />,
            <ClickableTypography
              key="link"
              perform={() => (window.location.href = `mailto:${paragraphLinks.emailIodBig}`)}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph14"
          values={{
            emailInfoBig: paragraphLinks.emailInfoBig,
            emailIodBig: paragraphLinks.emailIodBig,
          }}
        />
      </Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => window.open(paragraphLinks['15'], '_blank')}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph15"
          values={{
            link: paragraphLinks['15'],
          }}
        />
      </Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => (window.location.href = `mailto:${paragraphLinks.emailInfoBig}`)}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph16"
          values={{
            emailInfoBig: paragraphLinks.emailInfoBig,
          }}
        />
      </Typography>
      <Typography>
        <Trans
          components={[
            <ClickableTypography
              key="link"
              perform={() => (window.location.href = `mailto:${paragraphLinks.emailIodBig}`)}
            />,
          ]}
          i18nKey="loanFormPage.agreements.form.fields.bikbig.content.paragraph17"
          values={{
            emailIodBig: paragraphLinks.emailIodBig,
          }}
        />
      </Typography>

      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph18')}</Typography>

      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph19')}</Typography>

      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph20')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph21')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph22')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph23')}</Typography>
      <Typography>{t('loanFormPage.agreements.form.fields.bikbig.content.paragraph24')}</Typography>
    </Stack>
  );
}
